import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgOneTime = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M12.585 4.997a7.65 7.65 0 1 0 3.917 12.913 1 1 0 1 1 1.414 1.414 9.65 9.65 0 1 1 2.827-6.824 1 1 0 0 1-2 0 7.65 7.65 0 0 0-6.158-7.503"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      d="M13.733 16.5v-1.404h-1.488V7.884H11.02l-2.496 1.8.684 1.272 1.296-.924v5.064h-1.44V16.5z"
      fill={props.color}
    />
    <Path
      clipRule="evenodd"
      d="M22.871 11.793a1 1 0 0 1 0 1.414l-2.454 2.455a1 1 0 0 1-1.415 0l-2.454-2.455a1 1 0 0 1 1.414-1.414l1.748 1.747 1.747-1.747a1 1 0 0 1 1.414 0"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgOneTime);
export default Memo;
